import { render, staticRenderFns } from "./UserFolders.vue?vue&type=template&id=5834a070"
import script from "./UserFolders.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserFolders.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports